export default class ServiceResponse 
{
    constructor(hasError, messages)
    {
        this.hasError = hasError || false;
        this.messages = messages || [];
    }

    // pass in either a single message or an array of messages
    static toServiceResponse(messages, hasError = false)
    {
        return new ServiceResponse(hasError, Array.isArray(messages) ? messages : [messages]);
    }

    toMessageString()
    {
        if (!this.messages) return "";
        return (Array.isArray(this.messages) ? this.messages.join(' '): this.messages);
    }






}
